export interface VehicleTitleOptions {
  make: string | null;
  model?: string | null;
  trim?: string | null;
  variant?: string | null;
  makeOptions?: Array<{value: string; label: string}> | null;
  modelOptions?: Array<{value: string; label: string}> | null;
}

/**
 * Generates vehicle title from make, model, trim, and variant
 *
 * @param options Vehicle data for title generation
 * @returns Generated title string or null if no make provided
 */
export function generateVehicleTitle(options: VehicleTitleOptions): string | null {
  const {make, model, trim, variant, makeOptions, modelOptions} = options;

  if (!make) {
    return null;
  }

  const makeLabel = makeOptions?.find((m) => m.value === make)?.label || make;

  if (!model) {
    return makeLabel;
  }

  const modelLabel = modelOptions?.find((m) => m.value === model)?.label || model;
  const trimPart = trim ? ` ${trim}` : '';
  const variantPart = variant ? ` ${variant}` : '';

  return `${makeLabel} ${modelLabel}${trimPart}${variantPart}`;
}
